<template>
    <div>

        <div class="signin-area mg-top-90">

            <div class="container">

                <b-form v-if="$route.query.action == 'change'" validated @submit.prevent="handleResetPassword()">
                    <div class="signin-area-inner text-center">
                        <img src="assets/img/other/2.png" alt="img">
                        <h3>New Password
                        </h3>
                        <p>You must now reset your password to Sign In</p>
                    </div>

                    <div class="row">
                        <div class="col">
                            <label class="single-input-wrap">
                                <input type="email" id="normalEmail" required v-model="email" :disabled="true"
                                    placeholder="Enter Email" class="text-white">
                            </label>
                            <i class="fa fa-exclamation-circle text-danger"></i><small id="passwordHelpBlockMD"
                                class="form-text text-white pl-1 mb-1">{{ password_policy
                                }}</small>
                            <label class="single-input-wrap">
                                <input type="password" placeholder="Password" required v-model="password1"
                                    @keyup="checkpassword1()" autocomplete="new-password">
                            </label>
                            <span v-if="password1_feedback" class="text-danger">{{ password1_feedback
                            }}</span>

                            <label class="single-input-wrap">
                                <input type="password" placeholder="Confirm Password" required v-model="password2"
                                    @keyup="checkpassword2()" autocomplete="new-password">
                            </label>
                            <span v-if="password2_feedback" class="text-danger">{{ password2_feedback
                            }}</span>

                        </div>
                    </div>

                    <b-row align-v="center" no-gutters>
                        <b-col>
                            <button type="submit" class="btn-c btn-success mr-1 mb-2 btn-large w-100"
                                :disabled="reset">Password Reset</button>
                            <img v-show="busy"
                                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                            <div v-if="message" class="alert alert-danger mr-1 mb-2 w-100" role="alert">
                                {{ message }}
                            </div>
                            <div v-if="changed" class="alert alert-info mr-1 mb-2 w-100" role="alert">
                                {{ changed }}
                            </div>
                        </b-col>


                    </b-row>

                    <div class="form-check">
                        <div class="row">

                            <div class="col" style="text-align:right">
                                <span>Return to</span>
                                <router-link class="pl-0 text-success" to="/signin" @click="$router.push('/signin')">
                                    Sign in</router-link>
                            </div>
                        </div>
                    </div>
                </b-form>

                <b-form v-if="$route.query.action == 'forgot'" validated @submit.prevent="handleResetUser()">
                    <div class="signin-area-inner text-center">
                        <img src="assets/img/other/2.png" alt="img">
                        <h3>Forgot Password
                        </h3>
                        <p>Tell us your email address!</p>
                    </div>

                    <div class="row">
                        <div class="col">
                            <label class="single-input-wrap">
                                <input type="email" id="normalEmail" required v-model="email" :disabled="busy"
                                    placeholder="Enter Email">
                            </label>
                            <!-- <b-form-invalid-feedback id="usernameFeedback">Email is required</b-form-invalid-feedback> -->
                            <b-form-invalid-feedback id="usernameFeedback" class="alert alert-outline-danger dotted"
                                role="alert">
                                Email is required
                            </b-form-invalid-feedback>

                            <div v-if="changed" class="alert alert-info mr-1 mb-2 w-100" role="alert">
                                {{ changed }}
                            </div>


                        </div>
                    </div>



                    <b-row align-v="center" no-gutters>
                        <b-col>
                            <button type="submit" class="btn-c btn-success mr-1 mb-2 btn-large w-100"
                                :disabled="reset">Reset</button>
                            <!-- <b-button type="submit" variant="blue" class="btn-large btn-blue w-100 radius-50"
                  @click="handleSigninUser()">Sign in</b-button>&nbsp; -->
                            <img v-show="busy"
                                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        </b-col>
                    </b-row>

                    <div class="form-check">
                        <div class="row">

                            <div class="col" style="text-align:right">
                                <span>Return to</span>
                                <router-link class="pl-0 text-success" to="/signin" @click="$router.push('/signin')">
                                    Sign in</router-link>
                            </div>
                        </div>
                    </div>
                </b-form>

            </div>
        </div>


    </div>
</template>

<script>
import gql from "graphql-tag";

function parseJwt(token) {
    let jsonPayload = "{\"iat\":0,\"exp\":0}"
    if (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
    return JSON.parse(jsonPayload);
};


export default {
    name: "Reset",
    data() {
        return {
            ipinfo: "",
            busy: false,
            reset: false,
            email: null,
            token: null,
            message: null,
            changed: null,
            password1: null,
            password1Valid: false,
            password2: null,
            password2Valid: false,
            password1_feedback: "Password is required",
            password2_feedback: "Password is required",
            password_policy: "",
            password_expression: "",
        };
    },
    async mounted() {
        await this.loaddata();
    },
    methods: {
        async loaddata() {
            this.ipservice_url = await this.getsystemsetting("ipservice_url");
            if (this.$route.query.token) {
                this.token = parseJwt(this.$route.query.token)
            }
            if (this.$route.query.email) {
                this.email = this.$route.query.email
            }
            if (this.$route.query.action == 'change') {
                this.password_policy = await this.getsystemsetting("password_policy");
                this.password_expression = await this.getsystemsetting("password_expression");
            }
        },
        async getsystemsetting(name) {
            const response = await this.$apollo.query({
                query: gql`
            query setup_systemsettings($name: String) {
              setup_systemsettings(name: $name) {
                data
              }
            }
          `,
                variables: { name }
            });
            let result = response.data.setup_systemsettings[0].data;
            return result;
        },
        async get_ipaddress() {
            let result = "";
            // if (this.ipservice_url) {
            //   let ipinfo = await axios.get(this.ipservice_url);
            //   result = ipinfo.data.ip;
            // } else {
            result = "127.0.0.1";
            // }
            return result;
        },
        checkpassword1() {
            // CHECK POLICY
            let complexity = new RegExp(this.password_expression);
            if (complexity.test(this.password1)) {
                this.password1_feedback = "Password is OK";
                this.password1Valid = true;
                return true;
            } else {
                this.password1_feedback =
                    "Password does not meet the complexity requirements";
                this.password1Valid = false;
                return false;
            }
        },
        checkpassword2() {
            // CHECK POLICY
            let complexity = new RegExp(this.password_expression);
            if (complexity.test(this.password2)) {
                this.password2_feedback = "Password is OK";
            } else {
                this.password2_feedback =
                    "Password does not meet the complexity requirements";
                this.password2Valid = false;
                return false;
            }
            if (this.password1 == this.password2) {
                this.password2Valid = true;
                return true;
            } else {
                this.password2_feedback = "Password must match";
                this.password2Valid = false;
                return false;
            }
        },
        forgotPassword() {
            let variables = {
                rows: [{ email: this.email.toLowerCase() }],
                action: "forgot"

            }
            this.busy = true
            this.$apollo
                .query({
                    query: gql`
                        query setup_users_email($rows: [setup_users_input], $action: String) {
                            setup_users_email(rows: $rows, action: $action) {
                                id
                            }
                        }
                        `,
                    variables
                })
                .then(({ data }) => {
                    if (data.setup_users_email.length > 0) {
                        this.changed = "Thank-you, if your email address is known to us you will receive a password reset email shortly"
                        this.reset = true
                    }
                })
                .catch(err => {
                    console.error(err);
                });

            this.busy = false
        },
        changePassword() {

            let variables = {
                rows: [{ id: this.token.id, password: this.password1 }],
                token: this.$route.query.token
            }

            this.busy = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation setup_users_save($rows: [setup_users_input], $token: String) {
                            setup_users_save(rows: $rows, token: $token) {
                                id
                            }
                        }
                        `,
                    variables
                })
                .then(({ data }) => {
                    if (data.setup_users_save.length > 0) {
                        this.changed = "Thank-you, your password has now been changed, a confirmation email has been sent."
                        this.reset = true
                    }
                })
                .catch(err => {
                    this.message = err.message
                });

            this.busy = false

        },
        handleResetPassword() {
            this.changePassword();
        },
        handleResetUser() {
            this.forgotPassword();
        }
    }
};
</script>